export class DocumentFileVersionSign {
  documentVersionsFileCode: string;
  documentVerFilesSignId: number;
  documentSignUserId: number;
  documentUserSignsId: number;
  documentAcquaintUserId: number;
  documentAcquaintUserSignsId: number;
  documentAgreeUserId: number;
  documentAgreeUserSignsId: number;
  dateSign: string;
  signTimeStamp: string;
  fileName: string;
  fio: string;
  type: number;
  documentVersion: number;
  signSubFullName: number;
  signSubOrg: number;
  signSubIsOrganization: boolean;
  isStump: number;
  signSubIssuer: string;
  signingMethodId: number;
  isMainFile: boolean;
  signFileTypeId: number;
  documentVerFileSignId?: number;
  nestedLevel?: number;
  nestedIndex?: number;

  constructor(dto?: any) {
    this.documentVersionsFileCode = dto?.documentVersionsFilecode || '';
    this.documentVerFilesSignId = dto?.documentVerFilesSignId || 0;
    this.documentSignUserId = dto?.documentSignUserId || 0;
    this.documentUserSignsId = dto?.documentUserSignsId || 0;
    this.documentAcquaintUserId = dto?.documentAcquaintUserId || 0;
    this.documentAcquaintUserSignsId = dto?.documentAcquaintUserSignsId || 0;
    this.documentAgreeUserId = dto?.documentAgreeUserId || 0;
    this.documentAgreeUserSignsId = dto?.documentAgreeUserSignsId || 0;
    this.dateSign = dto?.dateSign || '';
    this.signTimeStamp = dto?.signTimeStamp || '';
    this.fileName = dto?.fileName || '';
    this.fio = dto?.fio || '';
    this.type = dto?.type || 0;
    this.documentVersion = dto?.documentVersion || 0;
    this.signSubFullName = dto?.signSubFullname || '';
    this.signSubOrg = dto?.signSubOrg || '';
    this.signSubIsOrganization = dto?.signSubIsOrganization || false;
    this.isStump = dto?.isStump || 0;
    this.signSubIssuer = dto?.signSubIssuer || '';
    this.signingMethodId = dto?.signingMethodId || 0;
    this.isMainFile = dto?.isMainFile || false;
    this.signFileTypeId = dto?.signFileTypeId || 0;
    this.documentVerFileSignId = dto && 'documentVerFileSignId' in dto ? dto.documentVerFileSignId : undefined;
    this.nestedLevel = dto && 'nestedLevel' in dto ? dto.nestedLevel : undefined;
    this.nestedIndex = dto && 'nestedIndex' in dto ? dto.nestedIndex : undefined;
  }
}

export class FileHashingResult {
  hasheBase64: string;
  pDocumentVersionsFileCode: string;
  fileName: string;
  isInternalNested: boolean;
  documentVerFileSignDataId: number;
  sign: string;

  constructor(dto?: any) {
    this.hasheBase64 = dto?.hasheBase64 || '';
    this.pDocumentVersionsFileCode = dto?.pDocumentVersionsFileCode || '';
    this.fileName = dto?.fileName || '';
    this.isInternalNested = dto?.isInternalNested || false;
    this.documentVerFileSignDataId = dto?.documentVerFileSignDataId || 0;
    this.sign = dto?.sign || '';
  }
}

export class FileSigningResult {
  pSignBase64: string;
  pDocumentVersionsFileCode: string;
  isInternalNested: boolean;
  documentVerFileSignDataId: number;

  constructor(dto?: any) {
    this.pSignBase64 = dto?.pSignBase64 || '';
    this.pDocumentVersionsFileCode = dto?.pDocumentVersionsFileCode || '';
    this.isInternalNested = dto?.isInternalNested || false;
    this.documentVerFileSignDataId = dto?.documentVerFileSignDataId || 0;
  }
}
